import { IdentifierDropdownMenu } from '~/components'
import { cn } from '../utils'
import { Badge, Avatar } from '~/elements'
import { type ComponentProps } from 'react'

type User = {
  id: string
  name?: string
  pictureUrl?: string
}

type Props = {
  user: User
  className?: string
  variant?: ComponentProps<typeof Badge>['variant']
}

export const UserBadge = ({ user, className, ...props }: Props) => {
  const userName = user.name ?? 'Unknown User'
  const displayName = userName === 'Unknown User' ? `Anonymous User` : userName
  const avatarName = userName === 'Unknown User' ? `Anonymous User ${user.id}` : userName

  return (
    <IdentifierDropdownMenu value={user.id} prefix={'user'}>
      <Badge {...props} className={cn('flex gap-2 px-2 hover:bg-neutral-50', className)} variant="outline">
        <Avatar name={avatarName} pictureUrl={user.pictureUrl} className="h-4 w-4 rounded-sm" />
        <span className="truncate text-neutral-900">{displayName}</span>
      </Badge>
    </IdentifierDropdownMenu>
  )
}
